export default "__VITE_ASSET__ilzI5PW9__"